@if (trainer) {
  <div class="row d-flex">
    <div class="col-12 col-lg-5 text-center">
      @if (trainer.image; as image) {
        <img class="img-fluid" [appSrcset]="image.url" [alt]="image.alt" pxWidth="640" />
      }
    </div>
    <div class="col-12 col-lg-6">
      <h2 class="px-4 px-sm-0 d-block mt-3 mt-lg-3">{{trainer.name}}</h2>
      <div class="px-4 px-sm-0 mb-3 mb-sm-0 description" [class.collapsed]="collapsed">
        @if (!isMobile()) {
          <span [innerHTML]="trainer.description | prismicText | hyphenateHtml | async"></span>
        }
        @if (isMobile()) {
          <ng-template nestedEllipsis nestedEllipsisWordBoundaries=" " [nestedEllipsisIndicator]="moreAnchor">
            <span [innerHTML]="trainer.description | prismicText"></span>
          </ng-template>
          <ng-template #moreAnchor>
            <button mat-button class="ms-1 read-more" disableRipple="true" color="accent" (click)="toggleReadMore()">
              {{'SINGLE_TRAINING.SHOW_MORE' | translate}}
            </button>
          </ng-template>
        }
      </div>
    </div>
  </div>
  @if (otherTrainings && otherTrainings.length > 0) {
    <div class="row d-sm-flex">
      <div class="col-12 pb-3">
        <h4 class="px-4 px-sm-0"><span translate>SINGLE_TRAINING.OTHER_TRAININGS_BY</span> {{trainer.name}}</h4>
      </div>
      @for (otherTraining of otherTrainings; track otherTraining) {
        <div class="col-12 col-lg-6 mb-3">
          <div class="px-4 px-sm-0">
            <app-trainer-other-training-card
              [title]="otherTraining.name"
              description=""
              [trainingCoverImageUrl]="otherTraining.lead_image?.url"
              [trainingUrl]="getTrainingLink(otherTraining.slug)">
            </app-trainer-other-training-card>
          </div>
        </div>
      }
    </div>
  }
}
